import React from 'react'
import { PlaceholderView } from './PlaceholderView'

export const IENotSupportedView = () => {
  return <PlaceholderView prefix="feature.placeholder.ie" />
}
